module.exports = __webpack_public_path__ + "media/fonts/aileron-thin-175fcc3c.woff";